import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";

import { ErrorBoundary } from "./bugsnag";

import App from "./App";

import Spinner from "./components/common/F7/Spinner";
import { PouchManager } from "./hooks/database/manager";
import { DatabaseContext } from "./hooks/database/useDatabases";
import { ApplicationStateProvider } from "./state";
import { notifyNewWorkerReady } from "./serviceWorkerControl";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import "openlayers/dist/ol.css";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("app") as HTMLElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <DatabaseContext.Provider value={new PouchManager()}>
        <ApplicationStateProvider>
          <HashRouter>
            <Suspense fallback={<Spinner />}>
              <App />
            </Suspense>
          </HashRouter>
        </ApplicationStateProvider>
      </DatabaseContext.Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({ onUpdate: notifyNewWorkerReady });
